window.jQuery = $;
window.$ = $;

document.addEventListener("turbolinks:load", function () {
  $("#supplier_phone_number").mask("(00) 0000-00009");
  $("#partner_phone_number").mask("(00) 0000-00009");

  const clientForm = $(".clientForm");
  if (!clientForm.length) return;

  function setClientFormLocked(locked) {
    clientForm.find(".client-field").prop("disabled", locked);
    clientForm.find(".client-field-label").prop("disabled", locked);
  }

  function populateClientFields(client) {
    $("#construction_client_name").val(client.name);
    $("#construction_client_document").val(client.document);
    $("#construction_client_rg").val(client.rg);
    $("#construction_client_rg_issuing_authority").val(client.rg_issuing_authority);
    $("#construction_client_marital_status").val(client.marital_status);
    $("#construction_client_nationality").val(client.nationality);
    $("#construction_client_phone_number").val(client.phone_number);
    $("#construction_client_address_zip_code").val(client.address_zip_code);
    $("#construction_client_address_street").val(client.address_street);
    $("#construction_client_address_number").val(client.address_number);
    $("#construction_client_address_complement").val(client.address_complement);
    $("#construction_client_address_district").val(client.address_district);
    $("#construction_client_address_state").val(client.address_state).trigger("change");
    $("#construction_client_address_city").val(client.address_city);
    $("#construction_client_address_city_code").val(client.address_city_code);
    $("#construction_client_id").val(client.id);
    $("#construction_client_password").attr("required", false);
  }

  function clearClientFields() {
    clientForm.find(".client-field").not("select").val("");
    clientForm.find("select.client-field").each(function () {
      if ($(this).hasClass("address_city_code_change")) {
        $(this).html("<option>Selecione um Estado primeiro</option>");
      } else {
        $(this).val("");
      }
    });
    $("#construction_client_id").val("");
    $("#construction_client_password").attr("required", true);
  }

  if ($("#construction_client_id").val()) {
    setClientFormLocked(false);
  }

  $(".clientByEmail").on("blur", function () {
    const element = $(this);
    const clientUrl = element.data("client-url");
    const token = $('meta[name="csrf-token"]').attr("content");
    const email = element.val();

    if (!element.valid() || email.length < 1) {
      setClientFormLocked(true);
      $("#construction_client_id").val("");
      return;
    }

    $.ajax({
      url: clientUrl,
      type: "GET",
      data: { email: email },
      beforeSend: function (xhr) {
        xhr.setRequestHeader("X-CSRF-Token", token);
      },
      success: function (response) {
        setClientFormLocked(false);
        clearClientFields();

        if (response.status != "not_found") {
          populateClientFields(response.client);
        } else {
          $("#construction_client_id").val("");
        }
      },
    });
  });
});
